import { defineFeatures } from "../define-provider-capability";

/**
 * The `revenuecat` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const revenuecatMobileFeatures = defineFeatures({
  // Mobile-side RevenueCat SDK keys. Production-only: preview + local
  // mobile builds disable the SDK (capabilities.allowed("revenuecat")
  // gates SDK init at runtime). Values live in mobile/prd Doppler.
  mobile: {
    scope: "runtime",
    environments: {
      local: {
        mode: "not-applicable",
        note: "Local mobile builds disable RevenueCat.",
      },
      preview: {
        mode: "not-applicable",
        note: "Preview mobile builds disable RevenueCat.",
      },
      production: { mode: "managed" },
    },
    env: [
      {
        name: "EXPO_PUBLIC_REVENUECAT_API_KEY_ANDROID",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "prd" },
      },
      {
        name: "EXPO_PUBLIC_REVENUECAT_API_KEY_IOS",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "prd" },
      },
      {
        name: "EXPO_PUBLIC_REVENUECAT_API_KEY_WEB",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "prd" },
      },
    ],
  },
});
